if (typeof customElements.get('search-promotion-carousel') === 'undefined') {
	class SearchPromotionCarousel extends HTMLElement {
		constructor() {
			super();
			this.flickity = null;
			this.sliderEl = null;
			this.searchModal = null;
			this.observer = null;
			this._resizeHandler = null;
			this._viewportHeightConstraint = null;
			this._viewportObserver = null;
		}

		connectedCallback() {
			this.sliderEl = this.querySelector('.quick-search__product-promotion-scroll');
			this.searchModal = document.getElementById('SearchModal');

			if (!this.sliderEl || !this.searchModal) return;

			this.observer = new MutationObserver((mutations) => {
				mutations.forEach((mutation) => {
					if (mutation.attributeName === 'class') {
						const isActive = mutation.target.classList.contains('modal--is-active');
						if (isActive) {
							setTimeout(() => {
								this._equalizeHeights();
								this._initSlider();
							}, 50);
						} else {
							this._destroySlider();
						}
					}
				});
			});

			this.observer.observe(this.searchModal, {
				attributes: true,
				attributeFilter: ['class'],
			});

			if (this.searchModal.classList.contains('modal--is-active')) {
				setTimeout(() => {
					this._equalizeHeights();
					this._initSlider();
				}, 100);
			}
		}

		disconnectedCallback() {
			if (this.observer) {
				this.observer.disconnect();
				this.observer = null;
			}
			if (this._viewportObserver) {
				this._viewportObserver.disconnect();
				this._viewportObserver = null;
			}
			if (this._resizeHandler) {
				window.removeEventListener('resize', this._resizeHandler);
				this._resizeHandler = null;
			}
			this._destroySlider();
		}

		_updateItemWidths() {
			const viewport = this.sliderEl?.querySelector('.flickity-viewport');
			if (!viewport) return;

			const viewportWidth = viewport.getBoundingClientRect().width;
			const items = this.sliderEl.querySelectorAll('.quick-search__product-promotion-scroll__product-promotion-item');
			if (items.length === 0) return;

			const isMobile = viewportWidth <= 479;
			const isTablet = viewportWidth > 479 && viewportWidth <= 750;

			let itemsPerRow, gap;
			if (isMobile) {
				itemsPerRow = 2;
				gap = 8;
			} else if (isTablet) {
				itemsPerRow = 3;
				gap = 10;
			} else {
				itemsPerRow = 4;
				gap = 12;
			}

			const gapsTotal = gap * (itemsPerRow - 1);
			const itemWidth = (viewportWidth - gapsTotal) / itemsPerRow;

			items.forEach((item, index) => {
				item.style.width = itemWidth + 'px';
				item.style.maxWidth = itemWidth + 'px';
				item.style.minWidth = itemWidth + 'px';
				if (index % itemsPerRow === itemsPerRow - 1 || index === items.length - 1) {
					item.style.marginRight = '0';
				} else {
					item.style.marginRight = gap + 'px';
				}
			});
		}

		_equalizeHeights() {
			const items = this.sliderEl.querySelectorAll('.quick-search__product-promotion-scroll__product-promotion-item');
			if (items.length === 0) return;

			// Only equalize if Flickity is enabled (when items are absolutely positioned)
			// Otherwise, flexbox with align-items: stretch handles it automatically
			if (!this.flickity || !this.sliderEl.classList.contains('flickity-enabled')) {
				return;
			}

			let maxHeight = 0;

			items.forEach((item) => {
				item.style.height = '';
				item.style.maxHeight = '';
				const gridProduct = item.querySelector('.grid-product');
				if (gridProduct) {
					gridProduct.style.height = '';
					gridProduct.style.maxHeight = '';
				}
			});

			void this.sliderEl.offsetHeight;

			items.forEach((item) => {
				const itemRect = item.getBoundingClientRect();
				const img = item.querySelector('img');
				const gridProduct = item.querySelector('.grid-product');
				const meta = item.querySelector('.grid-product__meta');

				let itemHeight = itemRect.height;
				if (img && img.naturalHeight && img.naturalWidth) {
					const itemWidth = itemRect.width;
					const imageAspectRatio = img.naturalHeight / img.naturalWidth;
					const imageHeightAtWidth = itemWidth * imageAspectRatio;
					const metaHeight = meta ? meta.getBoundingClientRect().height || 0 : 0;
					itemHeight = imageHeightAtWidth + metaHeight + 16; // 16px for padding/margins
				}

				if (itemHeight > maxHeight) {
					maxHeight = itemHeight;
				}
			});

			if (maxHeight > 0) {
				items.forEach((item) => {
					item.style.height = maxHeight + 'px';
					const gridProduct = item.querySelector('.grid-product');
					if (gridProduct) {
						gridProduct.style.height = '100%';
					}
				});
			}
		}

		_constrainToContainer() {
			const viewport = this.sliderEl?.querySelector('.flickity-viewport');
			if (!viewport) return;

			const promotionWrapper = this.sliderEl.closest('.quick-search__promotion-wrapper');
			const modalCentered = this.sliderEl.closest('.modal__centered-content') || this.sliderEl.closest('.modal__centered');

			if (!promotionWrapper || !modalCentered) return;

			const modalCenteredRect = modalCentered.getBoundingClientRect();
		const modalRect = modalCenteredRect; // Alias for backward compatibility
			const promotionRect = promotionWrapper.getBoundingClientRect();
			const windowHeight = window.innerHeight;

			const promotionHeading = promotionWrapper.querySelector('.quick-search__suggested-header');
			const headingHeight = promotionHeading ? promotionHeading.getBoundingClientRect().height + 10 : 0;
			const promotionTop = promotionRect.top + headingHeight + 20;
			const bottomMargin = 20;

			const availableHeightFromWindow = windowHeight - promotionTop - bottomMargin;
			const availableHeightFromModal = modalRect.bottom - promotionTop - bottomMargin;
			const availableHeight = Math.max(250, Math.min(availableHeightFromWindow, availableHeightFromModal));

			const promotionWrapperMaxHeight = headingHeight + 20 + availableHeight + 20;
			if (promotionWrapperMaxHeight > 0) {
				promotionWrapper.style.maxHeight = promotionWrapperMaxHeight + 'px';
				promotionWrapper.style.overflow = 'hidden';
			}

		const modalCenteredTop = modalCenteredRect.top;
		const maxModalCenteredHeight = windowHeight - modalCenteredTop - 20;
		if (maxModalCenteredHeight > 0) {
			modalCentered.style.maxHeight = maxModalCenteredHeight + 'px';
			modalCentered.style.height = 'auto';
		}

			const items = this.sliderEl.querySelectorAll('.quick-search__product-promotion-scroll__product-promotion-item');
			let maxItemHeight = 0;

			items.forEach((item) => {
				const itemRect = item.getBoundingClientRect();
				const img = item.querySelector('img');

				let itemHeight = itemRect.height;
				if (img && img.naturalHeight && img.naturalWidth) {
					const itemWidth = itemRect.width;
					const imageAspectRatio = img.naturalHeight / img.naturalWidth;
					const imageHeightAtWidth = itemWidth * imageAspectRatio;
					const meta = item.querySelector('.grid-product__meta');
					const metaHeight = meta ? meta.getBoundingClientRect().height || 0 : 0;
					itemHeight = imageHeightAtWidth + metaHeight + 16; // 16px for padding/margins
				}

				if (itemHeight > maxItemHeight) {
					maxItemHeight = itemHeight;
				}
			});

			const targetHeight = maxItemHeight || 250;
			let constrainedHeight = targetHeight;

			if (targetHeight > availableHeight && availableHeight > 0) {
				constrainedHeight = availableHeight;
			}

			const viewportMaxHeight = constrainedHeight;

			if (targetHeight > 0) {
				this._viewportHeightConstraint = constrainedHeight;

				if (this.flickity && items.length > 0) {
					items.forEach((item) => {
						item.style.height = constrainedHeight + 'px';
						item.style.maxHeight = constrainedHeight + 'px';
						item.style.minHeight = constrainedHeight + 'px';
						item.style.overflow = 'hidden';

						const gridProduct = item.querySelector('.grid-product');
						if (gridProduct) {
							gridProduct.style.height = '100%';
							gridProduct.style.maxHeight = '100%';
							gridProduct.style.overflow = 'hidden';
						}

						const meta = item.querySelector('.grid-product__meta');
						const metaHeight = meta ? Math.min(meta.getBoundingClientRect().height || 50, 60) : 50;
						const itemPadding = 8;
						const imageMaxHeight = Math.max(150, constrainedHeight - metaHeight - itemPadding);

						const imgWrapper = item.querySelector('.grid-product__image-wrapper');
						if (imgWrapper) {
							imgWrapper.style.maxHeight = `${imageMaxHeight}px`;
							imgWrapper.style.height = `${imageMaxHeight}px`;
							imgWrapper.style.overflow = 'hidden';
						}

						const img = item.querySelector('img');
						if (img) {
							img.style.objectFit = 'contain';
							img.style.maxHeight = '100%';
							img.style.width = '100%';
							img.style.height = 'auto';
						}

						if (meta) {
							meta.style.maxHeight = `${metaHeight}px`;
							meta.style.flexShrink = '0';
							meta.style.overflow = 'hidden';
						}
					});
				}

				viewport.style.maxHeight = viewportMaxHeight + 'px';
				viewport.style.height = constrainedHeight + 'px';
				viewport.style.minHeight = constrainedHeight + 'px';
				viewport.style.overflow = 'hidden';

				const flickitySlider = viewport.querySelector('.flickity-slider');
				if (flickitySlider) {
					flickitySlider.style.height = constrainedHeight + 'px';
					flickitySlider.style.maxHeight = constrainedHeight + 'px';
				}

				if (!this._viewportObserver) {
					this._viewportObserver = new MutationObserver((mutations) => {
						mutations.forEach((mutation) => {
							if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
								const currentHeight = viewport.style.height;
								const computedHeight = getComputedStyle(viewport).height;
								if (
									this._viewportHeightConstraint &&
									computedHeight !== `${this._viewportHeightConstraint}px` &&
									parseFloat(computedHeight) !== this._viewportHeightConstraint
								) {
									viewport.style.height = this._viewportHeightConstraint + 'px';
									viewport.style.maxHeight = viewportMaxHeight + 'px';
									viewport.style.minHeight = this._viewportHeightConstraint + 'px';
								}
							}
						});
					});
					this._viewportObserver.observe(viewport, {
						attributes: true,
						attributeFilter: ['style'],
					});
				}

				if (this.flickity && items.length > 0) {
					void viewport.offsetHeight;

					items.forEach((item) => {
						const itemRect = item.getBoundingClientRect();
						if (itemRect.height > constrainedHeight) {
							item.style.height = constrainedHeight + 'px';
							item.style.maxHeight = constrainedHeight + 'px';
							item.style.minHeight = constrainedHeight + 'px';
						}
					});

					if (this.flickity && typeof this.flickity.resize === 'function') {
						setTimeout(() => {
							items.forEach((item) => {
								item.style.height = constrainedHeight + 'px';
								item.style.maxHeight = constrainedHeight + 'px';
								item.style.minHeight = constrainedHeight + 'px';
							});

							this.flickity.resize();

							viewport.style.height = constrainedHeight + 'px';
							viewport.style.maxHeight = viewportMaxHeight + 'px';
							viewport.style.minHeight = constrainedHeight + 'px';
							if (flickitySlider) {
								flickitySlider.style.height = constrainedHeight + 'px';
								flickitySlider.style.maxHeight = constrainedHeight + 'px';
							}

							viewport.style.overflow = 'hidden';
						}, 100);
					}
				}
			}
		}

		_initSlider() {
			if (!this.sliderEl) {
				console.log('SearchPromotionCarousel: sliderEl not found');
				return;
			}
			if (this.flickity) return;

			const items = this.sliderEl.querySelectorAll('.quick-search__product-promotion-scroll__product-promotion-item');
			console.log('SearchPromotionCarousel: Found', items.length, 'items');

			if (items.length === 0) {
				console.log('SearchPromotionCarousel: No items found, retrying...');
				setTimeout(() => this._initSlider(), 100);
				return;
			}

			if (typeof Flickity === 'undefined') {
				console.log('SearchPromotionCarousel: Flickity not available, retrying...');
				setTimeout(() => this._initSlider(), 100);
				return;
			}

			console.log('SearchPromotionCarousel: Initializing Flickity...');

			const promotionWrapper = this.sliderEl.closest('.quick-search__promotion-wrapper');
			const modalCentered = this.sliderEl.closest('.modal__centered-content') || this.sliderEl.closest('.modal__centered');

			let preCalculatedHeight = null;
			if (promotionWrapper && modalCentered) {
				const promotionRect = promotionWrapper.getBoundingClientRect();
				const modalRect = modalCentered.getBoundingClientRect();
				const windowHeight = window.innerHeight;
				const bottomMargin = 20;

				const promotionHeading = promotionWrapper.querySelector('.quick-search__suggested-header');
				const headingHeight = promotionHeading ? promotionHeading.getBoundingClientRect().height + 10 : 0;
				const promotionTop = promotionRect.top + headingHeight + 20;

				const availableHeightFromWindow = windowHeight - promotionTop - bottomMargin;
				const availableHeightFromModal = modalRect.bottom - promotionTop - bottomMargin;

				preCalculatedHeight = Math.max(250, Math.min(availableHeightFromWindow, availableHeightFromModal));

				if (preCalculatedHeight > 0 && items.length > 0) {
					items.forEach((item) => {
						item.style.height = preCalculatedHeight + 'px';
						item.style.maxHeight = preCalculatedHeight + 'px';
						item.style.minHeight = preCalculatedHeight + 'px';

						const gridProduct = item.querySelector('.grid-product');
						if (gridProduct) {
							gridProduct.style.height = '100%';
							gridProduct.style.maxHeight = '100%';
						}

						const meta = item.querySelector('.grid-product__meta');
						const metaHeight = meta ? Math.min(meta.getBoundingClientRect().height || 50, 60) : 50;
						const itemPadding = 8;
						const imageMaxHeight = Math.max(150, preCalculatedHeight - metaHeight - itemPadding);

						const imgWrapper = item.querySelector('.grid-product__image-wrapper');
						if (imgWrapper) {
							imgWrapper.style.maxHeight = `${imageMaxHeight}px`;
							imgWrapper.style.height = `${imageMaxHeight}px`;
						}

						const img = item.querySelector('img');
						if (img) {
							img.style.objectFit = 'contain';
							img.style.maxHeight = '100%';
							img.style.width = '100%';
							img.style.height = 'auto';
						}

						if (meta) {
							meta.style.maxHeight = `${metaHeight}px`;
							meta.style.flexShrink = '0';
						}
					});

					this.sliderEl.style.maxHeight = preCalculatedHeight + 'px';
				}
			}

			this.flickity = new Flickity(this.sliderEl, {
				cellSelector: '.quick-search__product-promotion-scroll__product-promotion-item',
				draggable: true,
				freeScroll: true,
				wrapAround: false,
				prevNextButtons: false,
				pageDots: false,
				cellAlign: 'left',
				contain: true,
				groupCells: false,
				selectedAttraction: 0.025,
				friction: 0.28,
				dragThreshold: 3,
				percentPosition: true,
				setGallerySize: true,
				adaptiveHeight: false,
			});

			requestAnimationFrame(() => {
				const viewport = this.sliderEl.querySelector('.flickity-viewport');
				if (viewport && preCalculatedHeight) {
					viewport.style.height = preCalculatedHeight + 'px';
					viewport.style.maxHeight = preCalculatedHeight + 'px';
					viewport.style.minHeight = preCalculatedHeight + 'px';

					const flickitySlider = viewport.querySelector('.flickity-slider');
					if (flickitySlider) {
						flickitySlider.style.height = preCalculatedHeight + 'px';
					}
				}
			});

			setTimeout(() => {
				if (this.flickity) {
					this._updateItemWidths();
					this._constrainToContainer();
					this.flickity.resize();

					const viewport = this.sliderEl.querySelector('.flickity-viewport');
					if (viewport && (this._viewportHeightConstraint || preCalculatedHeight)) {
						const targetHeight = this._viewportHeightConstraint || preCalculatedHeight;
						viewport.style.height = targetHeight + 'px';
						viewport.style.maxHeight = targetHeight + 'px';
						viewport.style.minHeight = targetHeight + 'px';
					}
				}
			}, 50);

			this._resizeHandler = () => {
				if (this.flickity) {
					this._updateItemWidths();
					this._equalizeHeights();
					this._constrainToContainer();
					this._equalizeHeights();
					this.flickity.resize();
				}
			};
			window.addEventListener('resize', this._resizeHandler);

			console.log('SearchPromotionCarousel: Flickity initialized');
		}

		_destroySlider() {
			if (this.flickity && typeof this.flickity.destroy === 'function') {
				this.flickity.destroy();
				this.flickity = null;
			}
		}
	}

	customElements.define('search-promotion-carousel', SearchPromotionCarousel);
}
